import script from "./FormatMonth.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormatMonth.vue?vue&type=script&setup=true&lang=ts"

import "./FormatMonth.vue?vue&type=style&index=0&id=1d01958a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d01958a"]])

export default __exports__